import { createAsyncThunk } from "@reduxjs/toolkit";
import { Auth } from "../libs/utilities/helpers/Auth";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { encryptData, decryptData } from "../libs/utilities/helpers/Crypto";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_LOGIN;

export const login = createAsyncThunk(
  "auth/login",
  async ({ attar = {} }, { rejectWithValue }) => {
    try {
      // const encryptedPayload = await encryptData(JSON.stringify(attar));
      setBaseURL(api, DEV_BASE_URL);
      const response = await api.post("/user/login", attar);
      const encryptedString = response?.data?.data?.data;
      const decryptedString = await decryptData(encryptedString);
      const decryptedData = JSON.parse(decryptedString);
      Auth.register(decryptedData);
      const user = Auth.getUser({ auth: { user: decryptedData } });
      return user;
    } catch (error) {
      // handleApiError(error, 'login');
      return rejectWithValue(error.message);
    }
  });


export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      setBaseURL(api, DEV_BASE_URL);
      const response = await api.post("/user/logout");

      if (response.status === 201) {
        await Auth.deregister(dispatch);
        return {
          statusCode: response.status,
          message: response.data.message,
          data: response.data.data,
        };
      } else {
        throw new Error("Logout failed");
      }
    } catch (error) {
      console.error("Logout error:", error);
      return rejectWithValue(error.message);
    }
  }
);
